// ═══════════════════════════════════════════════
//   ONIGIRI WINGS — minigame
// ═══════════════════════════════════════════════
//
// Objective:   Tap to flap the onigiri through gaps in konbini shelves without crashing.
// Type:        timing
// Description: Click or SPACE to flap upward against gravity. Konbini shelves scroll
//              from right to left; each gap cleared scores a point and speeds things up.
//              Touching any shelf or the floor/ceiling ends the run instantly.
// Tunables:    GAME_ONIGIRI in data.js.

const {S, canvas, ctx, claimGameReward, addCleanup, showGameOver} = window;

window.onigiriShelves = [];

let oriX = 0, oriY = 0, oriVY = 0, oriSpeed = 0, oriSpawnT = 0;
let oriWingFrame = 0, oriLastFlap = -999, oriSparkles = [], oriTileOffset = 0;

const SHELF_PRODUCTS = ['🥛', '🧃', '🍫', '🍬', '🥤', '🍜', '🥚', '🍞', '🍡', '🍰'];
const TILE = 36; // konbini tile size in px

function startOnigiri() {
    const CFG = window.GAME_ONIGIRI;
    window.onigiriShelves = [];
    oriX = Math.floor(canvas.width * 0.22);
    oriY = canvas.height / 2;
    oriVY = 0;
    oriSpeed = CFG.scrollSpeed;
    oriSpawnT = 0;
    oriWingFrame = 0;
    oriLastFlap = -999;
    oriSparkles = [];
    oriTileOffset = 0;
    window.gameRunning = true;
    window.gameScore = 0;
    document.getElementById('mg-score').textContent = '0';
    document.getElementById('mg-timer').textContent = '∞';

    window.gameInterval = setInterval(onigiriLoop, 16);
    addCleanup(() => clearInterval(window.gameInterval));

    canvas.addEventListener('click', onigiriFlap);
    addCleanup(() => canvas.removeEventListener('click', onigiriFlap));

    document.addEventListener('keydown', onigiriKey);
    addCleanup(() => document.removeEventListener('keydown', onigiriKey));

    addCleanup(() => { window.onigiriShelves = []; oriSparkles = []; });
}

function onigiriFlap() {
    if (!window.gameRunning || S.currentGame !== 'onigiri') return;
    const CFG = window.GAME_ONIGIRI;
    oriVY = CFG.flapStrength;
    oriLastFlap = oriWingFrame;
    for (let i = 0; i < 4; i++) {
        oriSparkles.push({
            x: oriX + (Math.random() - 0.5) * 18,
            y: oriY + (Math.random() - 0.5) * 12,
            vx: (Math.random() - 0.5) * 1.5,
            vy: -Math.random() * 2 - 0.5,
            life: 14 + Math.floor(Math.random() * 8),
            r: Math.random() * 2.5 + 1,
        });
    }
}

function onigiriKey(e) {
    if (!window.gameRunning || S.currentGame !== 'onigiri') return;
    if (e.code === 'Space') { e.preventDefault(); onigiriFlap(); }
}

function drawOnigiri(x, y, vy, r, wingAge) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(Math.max(-0.4, Math.min(0.4, vy * 0.06)));

    const wf = Math.min(1, wingAge / 16);
    const liftY = -(1 - wf) * r * 0.35;

    // wings
    for (const side of [-1, 1]) {
        ctx.fillStyle = 'rgba(255,255,255,0.9)';
        ctx.strokeStyle = 'rgba(220,210,255,0.55)';
        ctx.lineWidth = 0.8;
        ctx.beginPath();
        ctx.ellipse(
            side * r * 1.08, liftY,
            r * 0.92, r * (0.38 + (1 - wf) * 0.18),
            side * (0.35 + (1 - wf) * 0.4),
            0, Math.PI * 2
        );
        ctx.fill();
        ctx.stroke();
    }

    // drop shadow
    ctx.fillStyle = 'rgba(0,0,0,0.15)';
    ctx.beginPath(); ctx.arc(1.5, 2.5, r, 0, Math.PI * 2); ctx.fill();

    // rice body
    ctx.fillStyle = '#fffef4';
    ctx.beginPath(); ctx.arc(0, 0, r, 0, Math.PI * 2); ctx.fill();

    // nori band (clipped)
    ctx.save();
    ctx.beginPath(); ctx.arc(0, 0, r, 0, Math.PI * 2); ctx.clip();
    ctx.fillStyle = '#1c2c1c';
    ctx.fillRect(-r, r * 0.24, r * 2, r * 0.84);
    ctx.restore();

    // body outline
    ctx.strokeStyle = 'rgba(150,140,120,0.35)';
    ctx.lineWidth = 1;
    ctx.beginPath(); ctx.arc(0, 0, r, 0, Math.PI * 2); ctx.stroke();

    // blush
    ctx.fillStyle = 'rgba(255,145,165,0.5)';
    ctx.beginPath(); ctx.ellipse(-r * 0.42, r * 0.04, r * 0.2, r * 0.11, 0, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.ellipse( r * 0.42, r * 0.04, r * 0.2, r * 0.11, 0, 0, Math.PI * 2); ctx.fill();

    // eyes
    ctx.fillStyle = '#222';
    ctx.beginPath(); ctx.arc(-r * 0.26, -r * 0.1, r * 0.1, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.arc( r * 0.26, -r * 0.1, r * 0.1, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = '#fff';
    ctx.beginPath(); ctx.arc(-r * 0.22, -r * 0.15, r * 0.04, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.arc( r * 0.30, -r * 0.15, r * 0.04, 0, Math.PI * 2); ctx.fill();

    ctx.restore();
}

function onigiriLoop() {
    if (!window.gameRunning) return;
    const CFG = window.GAME_ONIGIRI;
    const W = canvas.width;
    const H = canvas.height;
    const R  = CFG.oriRadius;
    const HR = CFG.hitRadius;

    oriWingFrame++;
    oriVY += CFG.gravity;
    oriY  += oriVY;

    // scroll tile offset with shelves
    oriTileOffset = (oriTileOffset + oriSpeed) % TILE;

    oriSpawnT++;
    if (oriSpawnT >= CFG.spawnEveryFrames) {
        oriSpawnT = 0;
        const halfGap = CFG.gapSize / 2;
        const margin  = halfGap + R + 12;
        const gapMid  = margin + Math.random() * (H - margin * 2);
        window.onigiriShelves.push({
            x: W + 10, gapMid, scored: false,
            product: SHELF_PRODUCTS[Math.floor(Math.random() * SHELF_PRODUCTS.length)],
        });
    }

    // ── konbini tile background ───────────────────────────────────────
    // grout
    ctx.fillStyle = '#ccc6dc';
    ctx.fillRect(0, 0, W, H);
    // tiles (scroll with shelves so they feel physically consistent)
    for (let ty = -TILE; ty < H + TILE; ty += TILE) {
        for (let tx = -oriTileOffset; tx < W + TILE; tx += TILE) {
            ctx.fillStyle = '#eae5f6';
            ctx.fillRect(tx + 2, ty + 2, TILE - 4, TILE - 4);
            // gloss strip along top edge
            ctx.fillStyle = 'rgba(255,255,255,0.38)';
            ctx.fillRect(tx + 2, ty + 2, TILE - 4, 3);
        }
    }

    // sparkles
    oriSparkles = oriSparkles.filter(sp => {
        sp.life--;
        if (sp.life <= 0) return false;
        sp.x += sp.vx; sp.y += sp.vy; sp.vy += 0.08;
        const a = (sp.life / 20).toFixed(2);
        ctx.fillStyle = `rgba(180,100,220,${a})`;
        ctx.beginPath(); ctx.arc(sp.x, sp.y, sp.r * (sp.life / 22), 0, Math.PI * 2); ctx.fill();
        return true;
    });

    // floor / ceiling boundary lines
    ctx.strokeStyle = 'rgba(200,60,140,0.7)';
    ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(0, 2);     ctx.lineTo(W, 2);     ctx.stroke();
    ctx.beginPath(); ctx.moveTo(0, H - 2); ctx.lineTo(W, H - 2); ctx.stroke();

    // ── shelves ───────────────────────────────────────────────────────
    let crashed = false;
    window.onigiriShelves = window.onigiriShelves.filter(sh => {
        sh.x -= oriSpeed;
        const sw     = CFG.shelfWidth;
        const gapTop = sh.gapMid - CFG.gapSize / 2;
        const gapBot = sh.gapMid + CFG.gapSize / 2;

        // top shelf
        ctx.fillStyle = '#432910';
        ctx.fillRect(sh.x, 0, sw, gapTop);
        ctx.fillStyle = '#6e4218';
        ctx.fillRect(sh.x - 2, gapTop - 9, sw + 4, 9);
        ctx.fillStyle = 'rgba(255,210,120,0.22)';
        ctx.fillRect(sh.x - 2, gapTop - 9, sw + 4, 3);
        ctx.strokeStyle = 'rgba(255,80,185,0.8)';
        ctx.lineWidth = 1.5;
        ctx.strokeRect(sh.x, 0, sw, gapTop);
        if (gapTop > 28) {
            ctx.font = '15px serif';
            ctx.textAlign = 'center';
            ctx.fillText(sh.product, sh.x + sw / 2, Math.max(20, gapTop - 16));
        }

        // bottom shelf
        ctx.fillStyle = '#432910';
        ctx.fillRect(sh.x, gapBot, sw, H - gapBot);
        ctx.fillStyle = '#6e4218';
        ctx.fillRect(sh.x - 2, gapBot, sw + 4, 9);
        ctx.fillStyle = 'rgba(255,210,120,0.22)';
        ctx.fillRect(sh.x - 2, gapBot, sw + 4, 3);
        ctx.strokeStyle = 'rgba(255,80,185,0.8)';
        ctx.lineWidth = 1.5;
        ctx.strokeRect(sh.x, gapBot, sw, H - gapBot);
        if (H - gapBot > 28) {
            ctx.font = '15px serif';
            ctx.textAlign = 'center';
            ctx.fillText(sh.product, sh.x + sw / 2, Math.min(H - 8, gapBot + 22));
        }

        // gap glow
        ctx.strokeStyle = 'rgba(200,160,255,0.13)';
        ctx.lineWidth = CFG.gapSize;
        ctx.beginPath();
        ctx.moveTo(sh.x + sw / 2, gapTop);
        ctx.lineTo(sh.x + sw / 2, gapBot);
        ctx.stroke();

        // score
        if (!sh.scored && sh.x + sw < oriX - HR) {
            sh.scored = true;
            window.gameScore++;
            document.getElementById('mg-score').textContent = window.gameScore;
            oriSpeed = Math.min(CFG.speedMax, oriSpeed + CFG.speedInc);
            SFX.play('hit');
        }

        // collision using hitRadius
        const inColumn = oriX + HR > sh.x && oriX - HR < sh.x + sw;
        if (inColumn && (oriY - HR < gapTop || oriY + HR > gapBot)) crashed = true;

        return sh.x + sw > -20;
    });

    if (oriY + HR > H - 2 || oriY - HR < 2) crashed = true;
    if (crashed) { endOnigiri(); return; }

    drawOnigiri(oriX, oriY, oriVY, R, oriWingFrame - oriLastFlap);
}

function endOnigiri() {
    const CFG = window.GAME_ONIGIRI;
    if (!window.gameRunning) return;
    window.gameRunning = false;
    SFX.play('damage');
    if (window.gameScore >= CFG.nickThreshold) window.unlockNick('night_shift');
    const p = Math.min(CFG.rewardMax, window.gameScore * CFG.rewardPer);
    showGameOver(claimGameReward('onigiri', window.gameScore, p));
}

window.startOnigiri = startOnigiri;
window.endOnigiri   = endOnigiri;
window.onigiriFlap  = onigiriFlap;
window.onigiriKey   = onigiriKey;
window.onigiriLoop  = onigiriLoop;
